<script setup>
import { SignIn } from '@clerk/vue'

import AuthPageLayout from '@web-app/login-app/AuthPageLayout'
import { useLoginAppRoutes } from '@web-app/utils/route-helpers'

defineOptions({
  name: 'WebAppSignIn'
})

const { gatewayPath } = useLoginAppRoutes()
</script>

<template>
  <AuthPageLayout>
    <SignIn :fallback-redirect-url="gatewayPath" />
  </AuthPageLayout>
</template>

<style scoped lang="scss"></style>
